import React from "react";
import AddQuickTalesToOrganizationContainer from "../../modules/AddQuickTalesToOrganization/containers/AddQuickTalesToOrganizationContainer/AddQuickTalesToOrganizationContainer";

const AddQuicktalesToOrg = () => {
  return <AddQuickTalesToOrganizationContainer />;
};

export default AddQuicktalesToOrg;
